import React from 'react';
import { Space, DatePicker, Select, Button } from 'antd';
import moment from 'moment';

const { Option } = Select;

const Filtros = ({
  selectedDate,
  selectedVendedor,
  selectedCliente,
  selectedEncuesta,
  vendedores,
  clientes,
  encuestas,
  conteoRespuestas,
  respuestas,
  onDateChange,
  onVendedorChange,
  onClienteChange,
  onEncuestaChange,
  onVerificarTodas
}) => {
  return (
    <Space wrap>
      <Select
        placeholder="Seleccionar encuesta"
        style={{ width: 200 }}
        value={selectedEncuesta}
        onChange={onEncuestaChange}
      >
        {encuestas.map((encuesta) => (
          <Option key={encuesta.id} value={encuesta.id}>
            {encuesta.nombre} 
          
          </Option>
        ))}
      </Select>
      
      <DatePicker
        placeholder="Seleccionar fecha"
        onChange={onDateChange}
        value={selectedDate}
        format="DD/MM/YYYY"
        disabled={!selectedEncuesta}
      />
      
      <Select
        placeholder="Seleccionar vendedor"
        style={{ width: 200 }}
        value={selectedVendedor}
        onChange={onVendedorChange}
        disabled={!selectedDate || !selectedEncuesta}
        allowClear
      >
        {vendedores.map((vendedor) => (
          <Option key={vendedor.id} value={vendedor.id}>
            {vendedor.nombre}
          </Option>
        ))}
      </Select>
      
      <Select
        placeholder="Seleccionar cliente"
        style={{ width: 200 }}
        value={selectedCliente}
        onChange={onClienteChange}
        disabled={!selectedVendedor || !selectedEncuesta}
        allowClear
      >
        {clientes.map((cliente) => (
          <Option key={cliente.id} value={cliente.id}>
            {cliente.nombre}
          </Option>
        ))}
      </Select>
      
      {respuestas.length > 0 && (
        <Button 
          type="primary" 
          onClick={onVerificarTodas}
          disabled={respuestas.every(resp => resp.verificada)}
        >
          Verificar Todas
        </Button>
      )}
    </Space>
  );
};

export default Filtros; 